import keys from '@/config/keys'
import store from '@/redux/store'

const getAppEventID = () => {
	const reduxState = store.getState()
	const { settings } = reduxState

	return settings[keys.FIELDS.eventId]
}

export default getAppEventID
